import axios from "axios";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { dateFormat, getStoreType, timeFormat } from "../../../../../dynamicController";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

import io from 'socket.io-client';

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const mySwal = withReactContent(Swal);

const STORETYPE = getStoreType()

const QrCode = () => {

    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();

    const [qrUrl, setQrUrl] = useState("");
    const [qrSrc, setQrSrc] = useState("");
    const [qrText, setQrText] = useState("");
    const [loading, setLoading] = useState(false);
    const [isIos/*, setIos*/] = useState(/iPhone|iPad|iPod/i.test(navigator.userAgent))
    const [copyTooltip, setCopyTooltip] = useState(false);

    useEffect(() => {
        if (location.state && location.state.text) {
            setQrText(location.state.text);
        }

        if (location.state && location.state.url) {
            setQrUrl(location.state.url)
            setQrSrc(location.state.url)

            setLoading(true);
            axios
                .post("/api/user/downloadQr", { url: location.state.url }, { responseType: 'blob' })
                .then(response => {
                    const blob = response.data
                    const downloadUrl = URL.createObjectURL(blob);
                    setQrSrc(downloadUrl)

                    // if (!isIos) {
                    //     const a = document.createElement('a');
                    //     a.href = downloadUrl;
                    //     a.download = `qr_${dateFormat(new Date())}_${timeFormat(new Date())}.png`;
                    //     document.body.appendChild(a);
                    //     a.click();
                    //     document.body.removeChild(a);
                    //     // URL.revokeObjectURL(downloadUrl);
                    // }

                    setLoading(false);
                })
                .catch(err => {
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                    setLoading(false);
                });
        }

        if (location.state && location.state.transactionId) {
            const socket = io({ transports: ['websocket'], auth: { transactionId: location.state.transactionId } })
            socket.on("duitnowPayment", (transactionId) => {
                if (location.state.kiosk) {
                    history.push("/kiosk")
                } else if (location.state.role === "staff") {
                    history.push("/staff")
                } else {
                    history.push("/thankyou")
                }
            })

            return () => {
                socket.disconnect();
            };
        }

    }, []);

    const downloadQR = () => {
        setLoading(true);
        axios
            .post("/api/user/downloadQr", { url: qrUrl }, { responseType: 'blob' })
            .then(response => {
                const blob = response.data
                const downloadUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = downloadUrl;
                a.download = `qr_${dateFormat(new Date())}_${timeFormat(new Date())}.png`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(downloadUrl);
                setLoading(false);
            })
            .catch(err => {
                mySwal.fire(t("Error"), t(err.response.data.error), "error");
                setLoading(false);
            });
    }

    const copy = () => {
        navigator.clipboard.writeText(qrText);
        setCopyTooltip(true);
        setTimeout(() => { setCopyTooltip(false) }, 1000);
    }

    return (
        <div id="setting-page" className="user-faq">
            <div id="setting-main">
                <div id="user-header">
                    <h5><i onClick={e => { location.state.kiosk ? history.push("/kiosk") : location.state.role === "staff" ? history.push("/staff") : history.push("/") }} className="bi bi-chevron-left me-3"></i> <strong>{t("QR code")}</strong></h5>
                </div>

                <div id="user-body">
                    {
                        qrUrl ? (
                            <div className="pt-3 pb-3">
                                <h4 className="ps-3">{t("Your QR code")}:</h4>
                                <div className="text-center">
                                    <img src={qrSrc} alt="qrcode" />
                                </div>
                                <div className="text-center d-flex justify-content-center">
                                    {/* <a className="btn btn-primary" href={`${getApiUrl()}/api/user/downloadQr?url=${qrUrl}`} download={`qr_${dateFormat(new Date())}_${timeFormat(new Date())}.png`}>{t("Download")}</a> */}
                                    {
                                        loading ? (
                                            <div className="text-center">
                                                <div className={STORETYPE === "cuci" ? "spinner-border text-warning" : "spinner-border text-primary"} role="status">
                                                    <span className="sr-only">Loading ...</span>
                                                </div>
                                            </div>
                                        ) : <button className="btn btn-primary d-flex align-items-center me-2" onClick={() => downloadQR()}><i className="bi bi-download me-1"></i>{t("Download")}</button>
                                    }
                                    {
                                        qrText ? (
                                            <OverlayTrigger
                                                placement="top"
                                                show={copyTooltip}
                                                overlay={<Tooltip>{t("Copied!")}</Tooltip>}
                                            >
                                                <button className="btn btn-primary d-flex align-items-center" onClick={() => copy()}><i className="bi bi-stickies me-1"></i>{t("Copy")}</button>
                                            </OverlayTrigger>
                                        ) : null
                                    }
                                </div>
                                {isIos ? <p className="text-center px-2 mt-2">{t('For iOS users, press and hold the image, then choose "Add to Photos" or "Save in Photos" from the menu.')}</p> : null}
                            </div>
                        ) : null
                    }
                </div>
            </div>
        </div>
    )
}

export default QrCode;